// Layout for the direct-request surfaces (bead hf-e6-commitments-coverage-udt.1).
//
// CSS-only, like every other feature stylesheet here.
//
// TWO LAYOUT DECISIONS CARRY MEANING, and neither is decoration:
//
//   THE TWO ANSWERS ARE THE SAME SIZE. `.asks__answers` is a flex row with equal
//   children and no size or emphasis difference. A prominent Yes beside a small "no
//   thanks" would tell somebody which answer the product wants — and this product has
//   no preference about whether a family member can drive on Tuesday. The component
//   file says the same thing; it is written twice because either half alone could be
//   changed by somebody who did not know the other existed.
//
//   THE ORGANISER'S GROUPS ARE FLAT. Asked, declined and said-yes get the same weight
//   and no colour. Only a LAPSED ask is emphasised, and that emphasis comes from
//   `StatusMessage tone="warning"` rather than from anything here — because a lapse is
//   the one thing on this panel the organiser has to act on (REQ-009), and colouring
//   "said yes" green would make a request panel look like a coverage panel.
export const requestStylesheet = `
.asks { display: grid; gap: var(--space-12, 0.75rem); }
.asks h2 { margin: 0; }
.asks__list { display: grid; gap: var(--space-12, 0.75rem);
  list-style: none; margin: 0; padding: 0; }
.asks__from { margin: 0; font-weight: 600; }
.asks__when, .asks__meaning, .asks__expires, .asks__link {
  margin: 0; color: var(--color-ink-muted, #5b6862); }
.asks__answers { display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem);
  margin-top: var(--space-8, 0.5rem); }

.asks-audience { display: grid; gap: var(--space-8, 0.5rem);
  margin-top: var(--space-16, 1rem); }
.asks-audience h3 { margin: 0; }
.asks-audience__group { display: grid; gap: var(--space-4, 0.25rem); }
.asks-audience__heading { margin: 0; font-weight: 600; }
.asks-audience__names { list-style: none; margin: 0; padding: 0;
  display: grid; gap: var(--space-4, 0.25rem); }
.asks-audience__names li { display: flex; flex-wrap: wrap; align-items: center;
  gap: var(--space-8, 0.5rem); }

/* Asking anyone in the circle (bead hf-mtk). One row per person, and the action
   sits ON the row rather than at the foot of the list — there is no list-level
   action to place there, and the layout should not suggest one exists. */
.asks__people { list-style: none; margin: 0; padding: 0;
  display: grid; gap: var(--space-12, 0.75rem); }
.asks__person { display: flex; flex-wrap: wrap; align-items: center;
  gap: var(--space-8, 0.5rem); }
.asks__person-name { margin: 0; font-weight: 600; }
.asks__person-relationship { margin: 0; color: var(--color-ink-muted, #5b6862); }
`;
